import enc from "@/utils/enc"
import { isEmpty } from '@/utils/validate'

const TokenInfo = 'YTH-TOKENINFO'
const UserInfo = 'YTH-USERINFO'
const Expires = 'YTH-EXPIRES'
const RefreshExpires = 'YTH-REFRESHEXPIRES'
const userMenu = 'YTH-USERMENU'
const Tags = 'YTH-TAGS'
const OperateTime = 'YTH-OPERATETIME'
const logoutFlag = 'YTH-LOGOUTFLAG'
const refreshToken = 'YTH-refreshToken'
const Storage = window.g.everyLogin ? sessionStorage:localStorage

const getLocalInfo = function (key) {
  const _info = Storage.getItem(key)
  const infoStr = isEmpty(_info) ? null : aesEec(_info)
  return infoStr
}
const setLocalInfo = function (info) {
  const _info = typeof info === 'object' ? JSON.stringify(info) : info
  const infoStr = isEmpty(_info) ? null : aesEnc(_info)
  return infoStr
}
// 加密
const aesEnc = function (val) {
  return decodeURIComponent(enc.AESEncrypt(val))
}
// 解密
const aesEec = function (val) {
  return enc.AESDecrypt(decodeURIComponent(val))
}

// Token 信息
export function getTokenInfo() {
  let info = getLocalInfo(TokenInfo)
  return info ? JSON.parse(info) : null
}
export function setTokenInfo(tokenInfo) {
  Storage.setItem(TokenInfo, setLocalInfo(tokenInfo))
}
export function removeTokenInfo() {
  Storage.removeItem(TokenInfo)
}

//Token 时间戳
export function setExpires(expires) {
  // const _exp = Math.floor((new Date().getTime() + expires) / 1000)
  // Storage.setItem(Expires, aesEnc(_exp))
  Storage.setItem(Expires, setLocalInfo(expires))
  // return Cookies.set(Expires, expires)
}
export function getExpires() {
  return getLocalInfo(Expires)
}
export function removeExpires() {
  return Storage.removeItem(Expires)
}
// Token 过期时间戳
export function setRefreshExpires(expires) {
  return Storage.setItem(RefreshExpires, expires)
}
export function getRefreshExpires() {
  return Storage.getItem(RefreshExpires)
}
export function removeRefreshExpires() {
  return Storage.removeItem(RefreshExpires)
}
// 用户信息
export function getUserInfo() {
  let info = getLocalInfo(UserInfo)
  return info ? JSON.parse(info) : null
}
export function setUserInfo(info) {
  return Storage.setItem(UserInfo, setLocalInfo(info))
}
export function removeUserInfo() {
  return Storage.removeItem(UserInfo)
}
// 用户菜单
export function getMenu() {
  return getLocalInfo(userMenu)
}
export function setMenu(info) {
  return Storage.setItem(userMenu, setLocalInfo(info))
}
export function removeMenu() {
  return Storage.removeItem(userMenu)
}
//用户操作权限
export function getTags() {
  return getLocalInfo(Tags)
}
export function setTags(tags) {
  return Storage.setItem(Tags, setLocalInfo(tags))
}
export function removeTags() {
  return Storage.removeItem(Tags)
}
//用户操作时间
export function getOperateTime() {
    return getLocalInfo(OperateTime)
  }
  export function setOperateTime(time) {
    return Storage.setItem(OperateTime, setLocalInfo(time))
  }
  export function removeOperateTime() {
    return Storage.removeItem(OperateTime)
  }
  //是否退出登录Flag
  export function getLogoutFlag() {
    return getLocalInfo(logoutFlag)
  }
  export function setLogoutFlag(time) {
    return Storage.setItem(logoutFlag, setLocalInfo(time))
  }
  export function removeLogoutFlag() {
    return Storage.removeItem(logoutFlag)
  }

//是否退出登录Flag
  export function getRefreshToken() {
    return getLocalInfo(refreshToken)
  }
  export function setRefreshToken(val) {
    return Storage.setItem(refreshToken, setLocalInfo(val))
  }
  export function removeRefreshToken() {
    return Storage.removeItem(refreshToken)
  }


// WEBPACK FOOTER //
// ./src/utils/auth.js